export { default as TeaserGridSection, type TeaserGridSectionProps } from './TeaserGridSection';
